import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormManager, PageTitle, Update, useCacheRecord } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { OrgUnit } from 'cb-model';

export const OrgUnitUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(OrgUnit, params.key);
  const handleExit = () => navigate(getListRowLink(OrgUnit.listRowLink, params.key));

  return (
    <>
      <PageTitle verb="Update" entity={OrgUnit} keyValue={params.key} />
      <FormManager
        compoundUrl="/main/~/save"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: { type: 'update-single', entity: OrgUnit, record },
        }}
      >
        <Update valuesKey="main" entity={OrgUnit} />
      </FormManager>
    </>
  );
};
